import { Box, Typography } from '@mui/material';
import { getEnvironment } from '../../../utils/helpers/getEnvironment';

const EnvironmentBadge = () => {
  const environment = getEnvironment();

  // Don't render badge for production
  if (!environment || environment === 'prod') {
    return null;
  }

  // Determine colors based on environment
  const getColors = () => {
    if (environment === 'dev') {
      return {
        bg: 'rgba(17, 156, 230, 0.15)', // Primary blue with transparency
        border: 'rgba(17, 156, 230, 0.3)',
        text: '#05629F', // Darker blue for text
        glow: 'rgba(17, 156, 230, 0.2)',
      };
    } else {
      // stage
      return {
        bg: 'rgba(255, 178, 63, 0.15)', // Orange/amber with transparency
        border: 'rgba(255, 178, 63, 0.3)',
        text: '#B8860B', // Dark amber for text
        glow: 'rgba(255, 178, 63, 0.2)',
      };
    }
  };

  const colors = getColors();
  const label = environment.toUpperCase();

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: 1.5,
        padding: '6px 14px',
        borderRadius: '20px',
        backgroundColor: colors.bg,
        backdropFilter: 'blur(10px) saturate(180%)',
        WebkitBackdropFilter: 'blur(10px) saturate(180%)',
        border: `1px solid ${colors.border}`,
        boxShadow: `0px 4px 12px ${colors.glow}, 0px 2px 4px rgba(0, 0, 0, 0.1)`,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: `0px 6px 16px ${colors.glow}, 0px 4px 8px rgba(0, 0, 0, 0.15)`,
        },
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: colors.text,
          marginRight: 1,
          boxShadow: `0 0 8px ${colors.glow}`,
          animation: 'pulse 2s ease-in-out infinite',
          '@keyframes pulse': {
            '0%, 100%': {
              opacity: 1,
              transform: 'scale(1)',
            },
            '50%': {
              opacity: 0.7,
              transform: 'scale(1.1)',
            },
          },
        }}
      />
      <Typography
        sx={{
          fontSize: '0.7rem',
          fontWeight: 600,
          color: colors.text,
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          fontFamily: 'monospace',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default EnvironmentBadge;
